export default {
  title: 'Carrello',
  buttons: {
    login_to_checkout: "Accedi per completare l'ordine",
    checkout: 'Checkout',
  },
  go_to_menu: 'Vai al menu',
  toasts: {
    cashback_points_removed: 'Il saldo dei tuoi punti è cambiato, quindi abbiamo rimosso i punti da questo ordine.',
  },
};
